class SizeChartPopup extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector('.size-chart-popup__trigger');
    this.dialog = this.querySelector('.size-chart-popup__dialog');
    this.closeBtn = this.querySelector('.size-chart-popup__close');

    if (!this.trigger || !this.dialog) return;

    this.trigger.addEventListener('click', () => {
      this.dialog.showModal();
    });

    this.closeBtn.addEventListener('click', () => {
      this.dialog.close();
    });

    // Click on the backdrop (outside the content) closes it
    this.dialog.addEventListener('click', (event) => {
      const rect = this.dialog.getBoundingClientRect();
      const clickedInside =
        event.clientX >= rect.left &&
        event.clientX <= rect.right &&
        event.clientY >= rect.top &&
        event.clientY <= rect.bottom;

      if (!clickedInside) {
        this.dialog.close();
      }
    });
  }
}

customElements.define('size-chart-popup', SizeChartPopup);